<template>
    <accordion-setting
        id="settingsImage"
        title="Configurações Imagem"
        :visible="visible"
    >
        <!-- CONFIGURAÇÃO DE PARALLAX -->
        <div
            v-if="isFullWidth && !isChild"
            class="py-2"
        >
            <div class="d-flex flex-column align-items-start">
                <label
                    for=""
                    class="font-14 my-2"
                >
                    Parallax
                </label>

                <button
                    style="background: transparent; border: transparent;"
                    @click="toggleParallax"
                >
                    <i v-if="hasParallax" class="fal fa-toggle-on text-success"></i>

                    <i v-else class="fal fa-toggle-off text-secondary"></i>
                </button>
            </div>
        </div>

        <!-- CONFIGURAÇÃO DE LARGURA -->
        <div class="py-2">
            <setting-frame-width
                :hasFullWidth="true"
                :item="item"
                @onChangeWidth="onChangeWidth"
            />
        </div>

        <!-- CONFIGURAÇÃO DE PREVIEW DA IMAGEM E TROCAR IMAGEM -->
        <div class="py-2">
            <setting-frame-image
                :url="activeUrl"
                @onChangeImage="onChangeImage"
            />
        </div>

        <!-- CONFIGURAÇÃO DE AÇÃO DO CLICK SOBRE A IMAGEM -->
        <div class="py-2">
            <label
                for="actionItem"
                class="font-14 my-2"
            >
                Ação
            </label>

            <select
                name="actionItem"
                id="actionItem"
                class="form-control"
                v-model="item.actionType"
                @change="handleSaveFrameConfig"
            >
                <option value="0">Nenhuma ação</option>
                <option value="1">Link na mesma aba</option>
                <option value="2">Link em nova aba</option>
            </select>

            <input
                type="text"
                placeholder="url (com https)"
                class="form-control mt-2"
                v-model="item.action"
                @change="handleSaveFrameConfig"
            />
        </div>

        <!-- CONFIGURAÇÃO DE MARGIN -->
        <div class="py-2">
            <setting-frame-margin
                v-if="!isFullWidth"
                :item="item"
                @onChangeMargin="onChangeMargin"
                @onChangeMarginMobile="onChangeMarginMobile"
                @onChangeLockMarginMobile="onChangeLockMarginMobile"
            />
        </div>
        
        <!-- CONFIGURAÇÃO DE PADDING -->
        <div class="py-2">
            <setting-frame-padding
                v-if="!isFullWidth"
                :item="item"
                @onChangePadding="onChangePadding"
                @onChangePaddingMobile="onChangePaddingMobile"
                @onChangeLockPaddingMobile="onChangeLockPaddingMobile"
            />
        </div>

        <!-- CONFIGURAÇÃO DE ALTURA -->
        <div class="py-2">
            <setting-frame-style-height
                :item="item"
                @onChangeStyleHeight="onChangeStyleHeight"
                @onChangeStyleHeightLock="onChangeStyleHeightLock"
            />
        </div>

        <!-- CONFIGURAÇÃO DE LARGURA -->
        <div v-if="isChild" class="py-2">
            <setting-frame-style-width
                :item="item"
                @onChangeStyleWidth="onChangeStyleWidth"
                @onChangeStyleWidthLock="onChangeStyleWidthLock"
            />
        </div>

        <!-- CONFIGURAÇÃO DE ARREDONDAMENTO DE BORDA -->
        <div class="py-2">
            <setting-frame-style-border-radius
                :item="item"
                :maxValue="!item.extra.style_height_lock ? parseInt(item.extra.style.height) / 2 : parseInt(item.height) / 2"
                @onChangeStyleBorderRadius="onChangeStyleBorderRadius"
            />
        </div>

        <div class="mt-3 d-flex justify-content-end">
            <button
                v-if="!isChild"
                class="btn btn-secundario py-2 mr-3"
                @click="transformInGallery"
            >
                Transformar em galeria
            </button>
        </div>
    </accordion-setting>
</template>

<script>
import SettingFrameWidth from "../atoms/SettingFrameWidth.vue";
import SettingFrameMargin from '../atoms/SettingFrameMargin.vue';
import SettingFramePadding from '../atoms/SettingFramePadding.vue';
import SettingFrameImage from '../atoms/SettingFrameImage.vue';
import AccordionSetting from '../atoms/AccordionSetting.vue';
import SettingFrameStyleWidth from '../atoms/SettingFrameStyleWidth.vue';
import SettingFrameStyleHeight from '../atoms/SettingFrameStyleHeight.vue';
import SettingFrameStyleBorderRadius from '../atoms/SettingFrameStyleBorderRadius.vue';

export default {
    name: "SettingsFrameImage",
    components: {
        SettingFrameWidth,
        SettingFrameMargin,
        SettingFramePadding,
        SettingFrameImage,
        AccordionSetting,
        SettingFrameStyleWidth,
        SettingFrameStyleHeight,
        SettingFrameStyleBorderRadius,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        },
        isChild: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },  
    computed: {
        activeUrl() {
            if (this.item.frameContent) return this.item.frameContent;
        },
        hasParallax() {
            if (this.item.extra.parallax) return true;

            return false;
        },
        isFullWidth() {
            if (this.item.grid == 99 || this.item.gridMobile == 99) return true;

            return false;
        }
    },
    methods: {
        handleSaveFrameConfig() {
            this.$emit("saveItemChanges", this.item);
        },
        resetSettings() {
            this.item.extra.background_color = null;
                            
            this.handleSaveFrameConfig();
        },
        onChangePadding(value) {
            this.item.extra.padding = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangePaddingMobile(value) {
            this.item.extra.padding_mobile = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeLockPaddingMobile(value) {
            this.item.extra.padding_mobile_lock = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeMargin(value) {
            this.item.extra.margin = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeMarginMobile(value) {
            this.item.extra.margin_mobile = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeLockMarginMobile(value) {
            this.item.extra.margin_mobile_lock = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeWidth(item) {
            if (item.grid !== 99) {
                this.item.extra.parallax = false;
            }

            this.item.grid = item.grid;
            this.item.gridMobile = item.gridMobile;
                            
            this.handleSaveFrameConfig();
        },
        onChangeImage(url) {
            this.item.frameContent = url;
                            
            this.handleSaveFrameConfig();
        },
        onChangeStyleHeight(value) {
            this.item.extra.style.height = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeStyleWidth(value) {
            this.item.extra.style.width = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeStyleBorderRadius(value) {
            this.item.extra.style.borderRadius = value;

            this.handleSaveFrameConfig();
        },
        onChangeStyleWidthLock(value) {
            this.item.extra.style_width_lock = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeStyleHeightLock(value) {
            this.item.extra.style_height_lock = value;
                            
            this.handleSaveFrameConfig();
        },
        transformInGallery() {
            this.$bvModal
                .msgBoxConfirm('Deseja mesmo trasformar a imagem em galeria?', {
                    title: "Transformar em galeria",
                    size: "md",
                    buttonSize: "sm",
                    cancelVariant: "secondary",
                    okVariant: "primary",
                    okTitle: "Confirmar",
                    cancelTitle: "Cancelar",
                    footerClass: "p-2",
                    hideHeaderClose: true,
                    centered: true,
                })
                .then((value) => {
                    if (!value) return;

                    const sidebarSettings = this.$parent;

                    sidebarSettings.$emit('transformInGallery',  this.item);
                });
        },
        toggleParallax() {
            this.item.extra.parallax = !this.item.extra.parallax;
                            
            this.handleSaveFrameConfig();
        },
    },
    created() {
        console.log(this.item, 'SettingsFrameImage');

        if (!this.item.extra) {
            this.item.extra = {};
        }

        if (typeof this.item.extra.parallax === 'undefined' || this.item.extra.parallax === null) {
            this.item.extra.parallax = false;
        }

        if (typeof this.item.extra.style === 'undefined' || this.item.extra.style === null) {
            this.item.extra.style = {
                height: '',
                width: '',
                borderRadius: '',
            };
        }

        if (typeof this.item.extra.style_height_lock === 'undefined' || this.item.extra.style_height_lock === null) {
            this.item.extra.style_height_lock = true;
        }

        if (typeof this.item.extra.style.height === 'undefined' || this.item.extra.style.height === null) {
            this.item.extra.style.height = '';
        }

        if (typeof this.item.extra.style_width_lock === 'undefined' || this.item.extra.style_width_lock === null) {
            this.item.extra.style_width_lock = true;
        }

        if (typeof this.item.extra.style.width === 'undefined' || this.item.extra.style.width === null) {
            this.item.extra.style.width = '';
        }

        if (typeof this.item.extra.style.borderRadius === 'undefined' || this.item.extra.style.borderRadius === null) {
            this.item.extra.style.borderRadius = '0px';
        }
    },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/molecules/SettingsFrameImage.vue